<template>
  <div v-show="visible">
    <div class="popup_wrap experimentType">
      <div class="popup_title">
        <p><span id="node_title">{{ getSelectedExperiment?.experimentName }} 상세보기
<!--          {{getExperimentTypeSaveFlag == "create"? "기본값SET 추가":"기본값SET 수정"}}-->
        </span></p>
        <a class="_command[CmmComm.closeLayer]">
          <div id="popup_close" class="btn_close" title="Close" @click="close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div class="node_order_wrap">
          <div class="node_order_box_middle">
            <h4 class="node_order_tit">타이틀</h4>
            <div class="node_name_box">
              <div class="box_stitle2 node_title W80" style="width: 100%">
                <input type="text" data-key="input" v-model="input.experimentName" style="width: 100%"
                       @input="inputListener($event,'experimentName')"
                       @keydown="keydownListener($event,'experimentName')"
                       :disabled="(getExperimentResultMode=='readOnly' && mode =='experiment') || (getProcessReadOnly && mode == 'process')"
                >
              </div>
            </div>
            <h4 v-if='selectedExperimentType!="DEFAULT" && selectedExperimentType!="RELEASE"' class="node_order_tit">
              공유여부</h4>
            <div v-if='selectedExperimentType!="DEFAULT" && selectedExperimentType!="RELEASE"' class="node_name_box">
              <div class="node_title W80">
                <div v-if='selectedExperimentType=="DEFAULT" && getExperimentTypeSaveFlag == "update"'>
                  <input type="radio" name="experimentType" id="DEFAULT" value="DEFAULT"
                         v-model="input.experimentType"/>
                  <label
                      for="DEFAULT">
                    <span>공정도 기본값</span>
                  </label>
                </div>
                <div v-if='selectedExperimentType=="RELEASE" && getExperimentTypeSaveFlag == "update"'>
                  <input type="radio" name="experimentType" id="RELEASE" value="RELEASE"
                         v-model="input.experimentType"/>
                  <label
                      for="RELEASE">
                    <span>공정도 기본값</span>
                  </label>
                </div>
                <div v-if='selectedExperimentType!="RELEASE" && selectedExperimentType!="DEFAULT"'>
                  <input type="radio" name="experimentType" id="SHARE" value="SHARE" v-model="input.experimentType"/>
                  <label for="SHARE">
                    <span>공유O</span>
                  </label>
                  <input type="radio" name="experimentType" id="CUSTOM" value="CUSTOM" v-model="input.experimentType"/>
                  <label for="CUSTOM">
                    <span>공유X</span>
                  </label>
                </div>
              </div>
            </div>
            <h4 class="node_order_tit">노드 목록</h4>
            <div v-if="mode=='experiment'" class="marking_top">
              <div class="marking_top_left">
                <button class="btn_basic" title="전체노드" @click="saveCustomSettings">커스텀설정저장</button>
<!--                <a class="tool_box tool_up" title="순서 올리기"></a>
                <a class="tool_box tool_down" title="순서 내리기"></a>-->
              </div>
              <div class="marking_top_right">
<!--                <button class="btn_basic" title="전체노드">전체노드보기</button>
                <button class="btn_basic" title="표시노드">표시노드보기</button>-->
              </div>
            </div>
            <!-- node Marking btnarea -->
            <ul class="node_marking_list">
              <li
                  v-for="(node,idx) in nodeArray"
                  :key="idx" :style="{'background-color': node.backgroundColor}"
                  :class="{ 'on' : targetNode.key == node.key}"
                  :draggable="true" @dragstart="dragStart($event,idx,'node')" @dragover.prevent
                  @drop="dragDrop($event,idx,'node')"
              >
                <div class="marking_nodetitle_wrap">
                  <div v-if="mode=='experiment'" class="marking_area_fold_area">
                    <a class="marking_area" @click="nodeVisibleCheck(node.key)"
                       :style="{'background-color': node.backgroundColor}"
                       :class="{ 'check_on' : node.nodeVisible}"
                    ></a>
                  </div>
                  <a class="marking_nodetitle" @click="nodeClick(node.key)">[{{ node.nodeOrder }}]. {{ node.text }}</a>
                  <div v-if="mode=='experiment'" class="marking_area_fold_area">
                    <!-- <button class="node_fold node_fold_down" title="펼치기">
                          </button>
                          <button class="node_fold node_fold_up" title="접기">
                          </button>
                          <button class="node_fold tool_up" title="펼치기">&nbsp;
                          </button
                          <button class="node_fold tool_down" title="접기">
                        </button>>-->
                    <button class="node_fold btn_node_change" style="background-color: white" title="드래그">
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="node_order_box_right">
            <div v-if="targetNode?.propertyArray?.length == 0">
              <div class="nodata_txt"><p>공정도 적용속성이 존재하지 않는 노드입니다.</p></div>
            </div>
            <div v-else>
              <div class="search_form_wrap">
                <ul class="search_form_list">
                  <li style="width: 87.5%;">
                    <div class="inpt_sch">
                      <input type="text" class="form_control" data-key="searchQuery" v-model="searchQuery"
                             style="background-color: white" placeholder="속성명 검색을 할수있어요."
                             @input="inputListener($event,'searchQuery')"
                             @keydown="keydownListener($event,'searchQuery')"
                      >
                      <button type="button"></button>
                    </div>
                  </li>
                  <li style="width: 12.5%;">
                    <div class="inpt_sch">
                      <button class="eraser" type="button" @click="resetSearchQuery"></button>
                    </div>
                  </li>
                </ul>
              </div>
              <p style="font-size: 14px; text-align: right">
                검색조건 결과 : {{ targetNodeSearchArray.length }}개 / 총 : {{ targetNode?.propertyArray?.length }}개
              </p>
              <div
                  v-for="(attr, index) in targetNodeSearchArray.filter(attr => attr.searchFlag)"
                  :key="index" class="node_result_box"
                  :draggable="true" @dragstart="dragStart($event,index,'attr')" @dragover.prevent
                  @drop="dragDrop($event,index,'attr')"
              >
                <h4 class="site_detail_tit">
                  {{ attr.propertyName }}
                  <!--추후 속성설명 추가시 해당건으로 처리-->
                  <div v-if="attr.propertyDefine != null && attr.propertyDefine != ''"
                       v-b-toggle="`experiment-type-collapse-${index}`"
                       class="tooltip_box" title="속성설명을 보려면 클릭해주세요.">
                    <span class="tooltip_ico"></span>
                  </div>
                  <div v-if="mode=='experiment'" class="node_result_box_btn">
                    <a class="btn_node_check" @click='attrVisibleCheck(attr.processPropertyId)' :class="attr.propertyVisible == true? 'on' : 'off'"></a>
                  </div>
                </h4>
                <div class="site_detail_con">
                  <h4 style="margin-bottom: 5px" class="site_detail_con">단위 :
                    {{ attr.propertyUnit != null && attr.propertyUnit != "" ? attr.propertyUnit : "없음" }} | 타입 : {{attr.propertyType != null? (attr.propertyType==PROPERTY_TYPE.STRING.value? 'TEXT' : attr.propertyType) : "-"}}</h4>
                  <input v-if="!isDistrictValid.includes(attr.propertyType)" type="text" class="W100"
                         data-key="experimentTypeAttribute" :data-attributeId="attr.processPropertyId"
                         @input="inputListener($event,attr.processPropertyId)"
                         @keydown="keydownListener($event,attr.processPropertyId)" v-model="attr.propertyValue"
                         :disabled="(getExperimentResultMode=='readOnly' && mode =='experiment') || (getProcessReadOnly && mode == 'process')"
                  >
                </div>
                <h4 class="custom_site_detail_con" v-if="!strIsNull(attr.propertyVocabulary?.code)">
                  어휘번호 :
                  {{createViewVocabularyString(attr.propertyVocabulary)}}
                </h4>
                <h4 class="custom_site_detail_con" v-if="!strIsNull(attr.propertyClass?.name)">class :
                  {{attr.propertyClass?.name}}
                </h4>
                <div v-if="attr.propertyDefine != null && attr.propertyDefine != ''">
                  <b-collapse :id="`experiment-type-collapse-${index}`" class="mt-2" style="cursor:default">
                    <b-card @click.stop>
                      <p style="white-space: pre-line; text-align: left;font-size: 13px; font-weight: bold">{{ attr.propertyDefine }}</p>
                    </b-card>
                  </b-collapse>
                </div>
              </div>
              <div v-if="targetNodeSearchArray.filter(attr => attr.searchFlag).length == 0">
                <div class="nodata_txt"><p>검색된 속성이 없습니다.</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup_footer">
<!--        SaveFlag : {{getExperimentTypeSaveFlag}}
        ||| ResultMode : {{getExperimentResultMode}}
        ||| ProcessReadOnly : {{getProcessReadOnly}} ||| user.committee : {{user.committee}} |||-->

<!--        1. : {{(getExperimentResultMode == 'edit' || (!getProcessReadOnly && (user.committee || user.admin) && $route.query.menuType == 'manager'))}}
        // 2. : {{getExperimentTypeSaveFlag == 'update'}}
        // 3. : {{ (getExperimentResultMode == 'edit' || (!getProcessReadOnly && (user.committee || user.admin) && $route.query.menuType == 'manager'))
            && getExperimentTypeSaveFlag == 'update'
            && (  selectedExperimentType=='SHARE'
                  || (selectedExperimentType=='CUSTOM' && getSelectedExperiment?.userId == user.id)
                  || (selectedExperimentType=='RELEASE' && (user.committee || user.admin))
                  || (selectedExperimentType=='DEFAULT' &&  (user.committee || user.admin))
              )}}-->
        <a v-if="getExperimentTypeSaveFlag == 'create'" class="btn_type1" @click="saveExperimentType">생성</a>
        <!--1. 실험타입이 공용일때. 2.실험타입이 커스텀이면서 작성자가 나일때. 3.실험타입이 release면서 user.commitee 일경우 4.실험타입이 default면서 user.commitee or admin 일경우-->
        <a
            v-if="(getExperimentResultMode == 'edit' || (!getProcessReadOnly && (user.committee || user.admin) && $route.query.menuType == 'manager'))
            && getExperimentTypeSaveFlag == 'update'
            && (  selectedExperimentType=='SHARE'
                  || (selectedExperimentType=='CUSTOM' && getSelectedExperiment?.userId == user.id)
                  || (selectedExperimentType=='RELEASE' && (user.committee || user.admin))
                  || (selectedExperimentType=='DEFAULT' &&  (user.committee || user.admin))
              )"
           class="btn_type1" @click="saveExperimentType">저장</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import CommNew from "@processEditor/CommNew";
import {createNamespacedHelpers} from 'vuex';
import {PROPERTY_TYPE,districtType} from "@/util/HubHandsonTable";
const Hub = createNamespacedHelpers('Hub');
const ProcessEditor = createNamespacedHelpers('ProcessEditor');

export default {
  mixins:[CommNew],
  components: {
    Loading,
  },
  data() {
    return {
      mode : null,
      loading : null,
      visible : false,
      nodeArray : [],
      input : {
        experimentName : null,
        experimentType : null,
      },
      experimentTypeAttribute:[],
      targetNode : {},
      searchQuery : null,
      PROPERTY_TYPE : PROPERTY_TYPE,
      draggedIndex: null, // 드래그한 항목의 인덱스를 저장
    }
  },
  computed : {
    ...Hub.mapGetters(
        ['getExperimentTypePopFlag'
          ,'getSelectedExperiment'
          ,'getProcessPropertyListOfExperiment'
          ,'getExperimentTypeSaveFlag'
          ,'getExperimentResultMode' //실험입력 읽기/수정모드 플래그
          ,'getCustomSettings'
      ]),
    //...CommNew.mapGetters(['getProcessReadOnly']),
    selectedExperimentType() {
      return this.getExperimentTypeSaveFlag == 'create'? null : this.getSelectedExperiment?.experimentType;
    },
    targetNodeSearchArray(){
       return this.targetNode?.propertyArray?.filter(attr => attr.searchFlag) || [];
    },
    isDistrictValid() {
      return districtType();
    }
  } ,
  watch: {
    getExperimentTypePopFlag: {
      async handler (value) {
        if(value === true){
          this.show();
          await this.getExperimentDetail();
        }else{
          this.visible = false;
          this.searchQuery = null;
        }
      }
    },
    getExperimentTypeSaveFlag: {
      deep: true,
      // immediate: true,
      async handler (value) {
        //console.log('[ExperimentType.vue]getExperimentTypeSaveFlag = ',value);
        Object.assign(this.input, {
            experimentName: this.getExperimentTypeSaveFlag == 'create'? "신규 기본값SET" : this.getSelectedExperiment.experimentName,
            experimentType: this.getExperimentTypeSaveFlag == 'create'? "SHARE" : this.getSelectedExperiment.experimentType
        });
      }
    },
    getProcessPropertyListOfExperiment: {
      deep: true,
      // immediate: true,
      async handler (value) {
        //console.log('[ExperimentType.vue]getProcessPropertyListOfExperiment = ',value);
        //깊은복사
        this.experimentTypeAttribute = JSON.parse(JSON.stringify(this.getProcessPropertyListOfExperiment)).map(attr => ({
          ...attr,
          searchFlag: true,
          propertyVisible : true,
        }));
      }
    },
    searchQuery : {
      handler (value) {
        //console.log('[ExperimentType.vue]searchQuery = ',value)
        if(value == null || value == ''){
          this.targetNode.propertyArray.forEach(attr => {
            attr.searchFlag = true;
          })
        }else{
          this.targetNode.propertyArray.forEach(attr => {
            if(attr.propertyName.toLowerCase().includes(value.toLowerCase())){
              attr.searchFlag = true;
            }else{
              attr.searchFlag = false;
            }
          });
        }
        //console.log('[ExperimentType.vue]experimentTypeAttribute=',this.experimentTypeAttribute.filter(attr => attr.searchFlag))
      }
    },
    /*nodeArray: {
      deep: true,
      async handler(value) {
        console.log('[ExperimentType.vue]nodeArray=', value);
      }
    }
    getSelectedExperiment: {
      deep: true,
      // immediate: true,
      async handler (value) {
        //console.log('[ExperimentType.vue]getSelectedExperiment = ',value);
      }
    },
    experimentTypeAttribute: {
      deep: true,
      // immediate: true,
      async handler (value) {
        //console.log('[ExperimentType.vue]experimentTypeAttribute=',value)
      }
    }*/
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setExperimentTypePopFlag"
        ]
    ),
    ...Hub.mapActions(
        [
          "fetchExperimentList","fetchReleaseProcessPropertyListOfProcess","fetchCustomSettings"
        ]
    ),
    async dragStart(event, index, fromFrame) {
      if(fromFrame=='attr' && this.searchQuery != null && this.searchQuery != ''){
        const flag = await window.confirm("순서변경을 위해 검색조건을 초기화하시겠습니까?");
        if(flag)this.searchQuery = null;
      }
      this.draggedIndex = index; // 드래그된 항목의 인덱스를 저장
      event.dataTransfer.setData("fromFrame", fromFrame); // 드래그한 영역 저장
      event.dataTransfer.effectAllowed = 'move';
    },
    dragDrop(event, dropIndex, targetFrame) {
      if (this.draggedIndex !== null && this.draggedIndex !== dropIndex) {
        const fromFrame = event.dataTransfer.getData("fromFrame"); // 드래그한 영역 가져오기
        if (fromFrame !== targetFrame) {
          console.log("다른 영역으로 이동 불가!");
          return;
        }
        // 드래그된 항목
        let draggedItem = null;
        if (targetFrame == 'node') {
          draggedItem = this.nodeArray[this.draggedIndex];
          // 드래그된 항목을 배열에서 삭제하고 새로운 위치에 추가
          this.nodeArray.splice(this.draggedIndex, 1); // 드래그된 항목 제거
          this.nodeArray.splice(dropIndex, 0, draggedItem); // 새로운 위치에 추가
          this.sortNodes();
        } else if (targetFrame == 'attr') {
          draggedItem = this.targetNode.propertyArray[this.draggedIndex];
          this.targetNode.propertyArray.splice(this.draggedIndex, 1);;
          this.targetNode.propertyArray.splice(dropIndex, 0, draggedItem);
          this.sortProcessAttributes();
        }
      }
      // 드래그 인덱스 초기화
      this.draggedIndex = null;
    },
    sortNodes() {
      // nodeCustomOrder를 순서대로 재설정
      let order = 1;
      this.nodeArray.forEach(item => {
          item.nodeCustomOrder = order++;
      });
      this.nodeArray.sort((a, b) => a.nodeCustomOrder - b.nodeCustomOrder);
    },
    sortProcessAttributes() {
      // propertyCustomOrder를 순서대로 재설정
      let order = 1;
      this.targetNode.propertyArray.forEach(item => {
          item.propertyCustomOrder = order++;
      });
      this.targetNode.propertyArray.sort((a, b) => a.propertyCustomOrder - b.propertyCustomOrder);
    },
    inputListener(v,id) {
      const target = v.target.getAttribute('data-key');
      switch (target){
        case "input":
          this[target][id] = v.target.value;
          break;
        case "searchQuery":
          this[target] = v.target.value;
          break;
        default :
          this[target].find(obj=> obj.processPropertyId == id).propertyValue = v.target.value;
          break;
      }
    },
    keydownListener(v,id) {
      const target = v.target.getAttribute('data-key');
      switch (target){
        case "input":
          this[target][id] = v.target.value;
          break;
        case "searchQuery":
          this[target] = v.target.value;
          break;
        default :
          this[target].find(obj=> obj.processPropertyId == id).propertyValue = v.target.value;
          break;
      }
    },
    nodeClick(key){
      this.searchQuery = null;
      this.targetNode = this.nodeArray.find(node => node.key == key);
    },
    nodeVisibleCheck(key){
      const target = this.nodeArray.find(node => node.key === key);
      if (!target) return;

      const newNodeVisible = !target.nodeVisible;
      target.nodeVisible = newNodeVisible;
      target.propertyArray?.forEach(attr => {
        attr.propertyVisible = newNodeVisible;
      });
    },
    attrVisibleCheck(processPropertyId) {
      const target = this.targetNode.propertyArray.find(attr => attr.processPropertyId == processPropertyId);
      if (!target) return;
      target.propertyVisible = !target.propertyVisible;
      const isTrue = this.targetNode.propertyArray.some(attr => attr.propertyVisible);
      const allFalse = this.targetNode.propertyArray.every(attr => !attr.propertyVisible);

      if (isTrue) {
        this.targetNode.nodeVisible = true;
      } else if (allFalse) {
        this.targetNode.nodeVisible = false;
      }
    },
    async saveCustomSettings() {
      const flag = await window.confirm("사용자 설정 저장 시 화면이 새로고침됩니다. 지금 적용하시겠습니까?");
      if (!flag) return;
      try {
        this.loading = true;
        const dataArray = [];
        this.nodeArray.forEach(node => {
          dataArray.push({
            processId : this.$route.query.processId
            ,dictionaryKeyLinkId : node.dictionaryKeyLinkId
            ,nodeCustomOrder : node.nodeCustomOrder
            ,nodeVisible : node.nodeVisible
            ,propertyList : node.propertyArray
          })
        });
        //console.log('data',dataArray)

        const response = await this.$wApi.experiment.custom.create(dataArray);
        if(!response.error){
          alert("현재 설정이 저장되었습니다.");
          //await this.fetchCustomSettings(this.$route.query.processId);
          location.reload();
        }
      } catch (e) {
        console.log('Error!!! [ExperimentType]saveCustomSettings', e)
      } finally {
        this.loading = false;
      }
    },
    async saveExperimentType(){
      this.loading = true;
      if(this.input.experimentType == null || this.input.experimentName == null || this.input.experimentName == ''){
        alert("타이틀과 공유여부를 입력해주세요.")
        return;
      }
      try {
        let res = null;
        let msg = '';

        const propertyList = [];
        this.nodeArray.forEach(node => {
          propertyList.push(...node.propertyArray)
        })

        if(this.getExperimentTypeSaveFlag == 'update'){
          const data = {
            processId : this.$route.query.processId,
            experimentId : this.getSelectedExperiment.experimentId,
            ...this.input,
            propertyList : propertyList,
          }
          res = await this.$wApi.experiment.updateExperiment({
            ...data
          });
          msg = "수정이 완료되었습니다.";
          //console.log('[ExperimentType.vue] save 호출',data)
        }else if(this.getExperimentTypeSaveFlag == 'create'){
          const data = {
            processId : this.$route.query.processId,
            ...this.input,
            propertyList : propertyList,
          }
          res = await this.$wApi.experiment.createExperiment({
            ...data
          });
          msg = "생성이 완료되었습니다.";
          //console.log('[ExperimentType.vue] save 호출',data)
        }

        if(!res.error){
          alert(msg);
          await this.fetchExperimentList({processId : this.$route.query.processId});
          //실험타입&값 업데이트 => 미사용
          //await this.fetchReleaseProcessPropertyListOfProcess({processId : this.$route.query.processId});
          this.close();
        }

      }catch (e){
        console.log('Error!!! [ExperimentType]saveExperimentType', e)
      }finally {
        this.loading = false;
      }
    },
    async processMode(){
      //공정도
      let response = await this.$wApi.process.detail(null, this.PROCESS_INFO.processId)
      const data = JSON.parse(response.json)
      let keyLinkRes = await this.$wApi.dictionary.getDictionaryKeyLinksByProcessId({
        processId : this.PROCESS_INFO.processId
      });
      if(data == null) throw new Error("잘못된 공정도 입니다. 관리자에게 문의해주세요.");
      data.nodes.forEach(node => {
        const matchedLink = keyLinkRes.find(link => link.tagKey === node.key);
        if(matchedLink){
          node.dictionaryKeyLinkId = matchedLink.id;
        }
      });
      return data.nodes;
    },
    async experimentMode() {
      //실험입력
      const response = await this.$wApi.process.release.get({
        processId: this.$route.query.processId
      });
      const data = JSON.parse(response.content)
      if(data == null) throw new Error("잘못된 공정도 입니다. 관리자에게 문의해주세요.");
      //노드 순서 적용
      let keyLinkRes = await this.$wApi.dictionary.getReleaseDictionaryKeyLinksByReleaseProcessId({
        idReleaseProcess: response.idReleaseProcess
      });

      data.nodes.forEach(node => {
        const matchedLink = keyLinkRes.find(link => link.tagKey === node.key);
        if (matchedLink) {
          node.dictionaryKeyLinkId = matchedLink.dictionaryKeyLinkId;
        }

      });
      return data.nodes;
    },
    async getExperimentDetail() {
      this.loading = true
      try {
        let nodes = null;
        if (this.$route.path.includes('experiment') && this.$route.query.menuType === "researcher") {
          nodes = await this.experimentMode();
          this.mode = 'experiment';
        } else if (this.$route.path.includes('process') && this.$route.query.menuType === "manager") {
          nodes = await this.processMode();
          this.mode = 'process';
        } else {
          this.loading = false;
          this.close();
          alert('잘못된 접근입니다.');
          this.$router.push({
            path: '/experiment/gate',
            query: {
              editorType: 'gate'
            }
          });
          return;
        }
        //keyLink 매핑
        this.nodeArray = [];
        nodes.forEach(node => {
          if (node.dictionaryKeyLinkId != null) {
            //노드별 색설정.
            switch (node.category) {
              case "PROCESS":
                node.backgroundColor = '#D8E5F5';
                break;
              case "MATERIAL":
                node.backgroundColor = '#E2DDE9';
                break;
              case "EQUIPMENT":
                node.backgroundColor = '#DAEDE8';
                break;
            }
          }

          let customNode = null;
          if(this.getCustomSettings && this.getCustomSettings.length > 0 && this.mode == 'experiment') customNode = this.getCustomSettings.find(customNode => customNode.dictionaryKeyLinkId == node.dictionaryKeyLinkId);

          //노드와 속성 매핑
          const propertyArray = this.experimentTypeAttribute.filter(attr => attr && attr.active && attr.dictionaryKeyLinkId == node.dictionaryKeyLinkId).map(attr => {
            let userCustomProp= null;
            if(customNode){
              userCustomProp = customNode.propertyCustomOrderList.find(prop => prop.processPropertyId == attr.processPropertyId);
            }
            return {
              ...attr,
              propertyVisible : userCustomProp?.propertyVisible ?? true, //새로 추가된 속성이라면 기본값 true
              propertyCustomOrder : userCustomProp?.propertyCustomOrder ?? attr.propertyOrder, //새로 추가된 속성이라면 기존 공정도 속성 순서 적용
            };
          }).sort((a,b) => a.propertyCustomOrder - b.propertyCustomOrder);

          //노드와 속성 매핑
          this.nodeArray.push(
              {
                ...node
                , "propertyArray": [...propertyArray]
                , nodeVisible : customNode?.nodeVisible ?? true //새로 추가된 노드라면 기본값 true
                , nodeCustomOrder : customNode?.nodeCustomOrder ?? node.nodeOrder //새로추가된 노드라면 기존 공정도 순서 적용
              },
          );
        });
        this.nodeArray.sort((a,b) => a.nodeCustomOrder - b.nodeCustomOrder);
        //첫번째 선택
        if (this.nodeArray.length > 0) this.targetNode = this.nodeArray[0];
        this.loading = false
      } catch (error) {
        alert(`error! ${error}`);
        this.loading = false
        this.close();
      }
      this.loading = false
    },
    resetSearchQuery(){
      this.searchQuery = null;
    },
    show() {
      this.visible = true;
    },
    close() {
      this.setExperimentTypePopFlag(false);
    },
    label(category){
      let label = '';
      switch (category){
        case "MATERIAL":
          label = '재료';
          break;
        case "PROCESS":
          label = '공정';
          break;
        case "EQUIPMENT":
          label = '장비';
          break;
      }
      return label;
    },
    strIsNull(string){
      return string == null || string == ""
    },
    createViewVocabularyString(propertyVocabulary){
      let result = "";
      if(propertyVocabulary == null){
        return result;
      }
      result += propertyVocabulary.code + "(";
      if(propertyVocabulary.system1 != null && propertyVocabulary.system1){
        result += propertyVocabulary.system1;  
      }
      if(propertyVocabulary.system2 != null && propertyVocabulary.system2){
        result += " / " + propertyVocabulary.system2;   
      }
      result += ")";
      return result;
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";
.experimentType  {display:block;position:fixed; width:900px;height:80%;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:999; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}

@media screen and (max-width: 950px) {
  .experimentType {width:95%;}
}
  
.custom_site_detail_con { color: #555; font-family: "Noto Sans KR Medium"; font-size: 14px; line-height: 24px;}

</style>